@if (filteredClients$ | async; as filteredClients) {
  <ionic-selectable
    #selectableComponent
    [(ngModel)]="selectedItem"
    itemValueField="id"
    itemTextField="fullname"
    [items]="filteredClients"
    [shouldFocusSearchbar]="true"
    [canSearch]="true"
    [disabled]="disabled"
    (onSearch)="searchClients($event.text)"
    (onChange)="itemSelected($event)"
  >
    <ng-template ionicSelectableValueTemplate let-client="value">
      {{ client.user?.fullname }}
    </ng-template>
    <ng-template ionicSelectableHeaderTemplate>
      <ion-toolbar>
        <ion-buttons slot="primary">
          <ion-button (click)="closeClientSelect()">
            <ion-icon slot="icon-only" name="close"></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-title>Klient</ion-title>
      </ion-toolbar>
    </ng-template>
    <ng-template ionicSelectableItemTemplate let-client="item">
      {{ client.user?.fullname }}
    </ng-template>
  </ionic-selectable>
}
